var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container"},[_c('switch-dark-mode',{staticClass:"d-none"}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"d-block m-auto",attrs:{"src":require("@/assets/logo/logo-black-square.svg"),"width":"100","height":"100"}})])
}]

export { render, staticRenderFns }